import { render, staticRenderFns } from "./AddOrEditB2BAssessmentPackage.vue?vue&type=template&id=1dfa852e"
import script from "./AddOrEditB2BAssessmentPackage.vue?vue&type=script&lang=js"
export * from "./AddOrEditB2BAssessmentPackage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports